/*
* 组织秘钥管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    CopyToClipboard,
    isGTscreenWidth,
    GetDropdownActionName,
    ShowIPModal,
} from '../../incs/FunHelper.js';

import Entity from './OrgApikeyEntity.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[3].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) => { this.props.setOpen(true, record); }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'org/apikeys/' + record.key;
        switch (action) {
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.username, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    render() {
        const _this = this;
        const columns = [
            { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
            { title: '前缀', dataIndex: 'group_prefix', key: 'group_prefix', },
            { title: '服务代码', dataIndex: 'service_code', key: 'service_code', },
            {
                title: 'ApiKey', key: 'api_key_value',
                render: function (record) {
                    return <div style={{
                        color: _this.props.colorPrimary ? _this.props.colorPrimary : CNF.themeColors[0],
                        cursor: 'pointer'
                    }}
                        onClick={(e) => {
                            CopyToClipboard(record.api_key_value);
                            e.preventDefault();
                        }}
                    >{record.api_key_value.slice(0, 15) + record.api_key_value.slice(-15).replace(/./g, '*')}</div>
                }
            },
            {
                title: 'ApiSecret', key: 'api_key_secret',
                render: function (record) {
                    return <div style={{
                        color: _this.props.colorPrimary ? _this.props.colorPrimary : CNF.themeColors[0],
                        cursor: 'pointer'
                    }}
                        onClick={(e) => {
                            CopyToClipboard(record.api_key_secret);
                            e.preventDefault();
                        }}
                    >**********</div>
                }
            },
            { title: '备注', dataIndex: 'description', key: 'description', },
            {
                title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth,
            },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right',
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            serviceCode: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeServiceCode = (value) => { this.setState({ serviceCode: value ? value : '' }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'service_code': this.state.serviceCode,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}org/apikeys${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Select
                            allowClear
                            placeholder='服务代码'
                            style={{ width: '100%' }}
                            onChange={this.changeServiceCode}
                        >
                            {
                                this.props.serviceCodes && this.props.serviceCodes.map((item) => {
                                    return <Option key={item} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder="状态"
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        btnLists={this.props.btnLists}
                        serviceCodes={this.props.serviceCodes}
                        record={this.state.record}
                        open={this.state.open}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            colorPrimary={this.props.colorPrimary}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT